import _isEmpty from 'lodash/isEmpty';
import { isTakeoutOrder } from '../../../../../../services/checkout/order';
import { isValidEmail, isValidPhoneNumber } from '../../../../../../utils/strings';
export function isValidFulfillmentInformation() {
  var fulfillmentData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _fulfillmentData$firs = fulfillmentData.firstName,
    firstName = _fulfillmentData$firs === void 0 ? '' : _fulfillmentData$firs,
    _fulfillmentData$last = fulfillmentData.lastName,
    lastName = _fulfillmentData$last === void 0 ? '' : _fulfillmentData$last,
    _fulfillmentData$coun = fulfillmentData.country,
    country = _fulfillmentData$coun === void 0 ? '' : _fulfillmentData$coun,
    _fulfillmentData$stat = fulfillmentData.state,
    state = _fulfillmentData$stat === void 0 ? '' : _fulfillmentData$stat,
    _fulfillmentData$city = fulfillmentData.city,
    city = _fulfillmentData$city === void 0 ? '' : _fulfillmentData$city,
    _fulfillmentData$post = fulfillmentData.postalCode,
    postalCode = _fulfillmentData$post === void 0 ? '' : _fulfillmentData$post,
    _fulfillmentData$line = fulfillmentData.line1,
    line1 = _fulfillmentData$line === void 0 ? '' : _fulfillmentData$line,
    _fulfillmentData$isVe = fulfillmentData.isVerified,
    isVerified = _fulfillmentData$isVe === void 0 ? false : _fulfillmentData$isVe;
  var addressIsComplete = !_isEmpty(country) && !_isEmpty(state) && !_isEmpty(city) && !_isEmpty(postalCode) && !_isEmpty(line1) && isVerified;
  return !_isEmpty(firstName) && !_isEmpty(lastName) && addressIsComplete;
}
export function isValidCustomerInformation() {
  var customerData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _customerData$firstNa = customerData.firstName,
    firstName = _customerData$firstNa === void 0 ? '' : _customerData$firstNa,
    _customerData$lastNam = customerData.lastName,
    lastName = _customerData$lastNam === void 0 ? '' : _customerData$lastNam,
    _customerData$email = customerData.email,
    email = _customerData$email === void 0 ? '' : _customerData$email,
    _customerData$phoneNu = customerData.phoneNumber,
    phoneNumber = _customerData$phoneNu === void 0 ? '' : _customerData$phoneNu;
  return !_isEmpty(firstName) && !_isEmpty(lastName) && isValidPhoneNumber(phoneNumber) && isValidEmail(email);
}
export function getFulfillmentCopy() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (isTakeoutOrder(order)) {
    return 'Pick-up only';
  }
  return '';
}
export function getStepsBeingEditedCount() {
  var stepsBeingEdited = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.values(stepsBeingEdited).filter(function (step) {
    return !!step;
  }).length;
}